module.exports = __webpack_public_path__ + "static/media/photo53.61c63132.jpg";